import React, { useEffect, useState } from 'react';
import LawyerContacted from '../../components/LawyerContacted';
import MainTitle from '../../components/MainTitle';
import EmptyState from '../../components/EmptyState';
import Banner from '../../components/Banners/Banner';
import FilterDropdown from '../../components/Modal/FilterDropdown';
import MessageClient from '../../components/Messaging/containers/MessageClient';
import Instructions from '../../components/Messaging/containers/Instructions';

import useMediaQuery from '@material-ui/core/useMediaQuery';
import { isMobile } from 'react-device-detect';

import {
  deleteMessage,
  readMessage,
  saveMessage,
} from '../../store/actions/UserAction';
import { useHistory } from "react-router-dom";
import { height } from 'styled-system';
const filter = '/img/icons/filters.svg';
const lawyersList = [
  /* {
    id: 1,
    name: 'López Abogados S.A. de C.V.',
    location: 'Polanco 53125, CDMX',
    mobile: '00-0000-0000',
    office: '00-0000-0000',
    email: 'atencionClientes@lopezabogados.com',
    whatsapp: '00-0000-0000',
    website: 'lopezabogados.com',
    //image: 'https://www.onlinelogomaker.com/blog/wp-content/uploads/2017/07/law-firm-logo.jpg',
    role: 'lawyer',
    gender: 'female'
  }, */
];

const LawyersContactedContainer = (props) => {
  const history = useHistory();

  const tabletSize = useMediaQuery('(max-width:768px)');

  const [expanded, setExpanded] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success',
  });
  const [open, setOpen] = useState(false);
  const [msgToDelete, setMsgToDelete] = useState(null);

  const mobileVersion = useMediaQuery('(max-width: 1279px)');

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickDelete = (message) => {
    setOpen(true);
    setMsgToDelete(message);
  };
 

  const handleChange = (msg, index) => (event, isExpanded) => {
    setExpanded(isExpanded ? index : false);

  };

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'success',
    });
  };

  const handleSave = (msg) => {
   
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [option, setOption] = useState('week');
  const [apply, setApply] = useState(false);

  const handleClickDropdown = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleOption = (event, option) => {
    setApply(false);
    setOption(option);
  };
  const handleCloseDropdown = () => {
    setAnchorEl(null);
  };

  const openDropdown = Boolean(anchorEl);
  const id = openDropdown ? 'simple-popover' : undefined;
  


  if (true) {
    return (
      <EmptyState
        title="Comienza a resolver tus problemas legales."
        subtitle="En esta sección encontraras las conversaciones con los abogados que contactes. No esperes más."
        img='/img/LandingClient/Csearch.svg'
        handleClick={() => history.push('/busqueda')}
        callToAction="Buscar abogados"
      />
    );
  }
  return (
    <div className="lawyersContacted">
      <div className="lawyersContacted-title">
        <MainTitle title="Abogados contactados" />
      </div>
      <div className="lawyersContacted-content">
        <main className="lawyersContacted-main">
          {lawyersList.map((lawyer,index) => {
            return (
              <LawyerContacted
                key={index}
                {...lawyer}
              />
            );
          })}
        </main>
        <aside className="lawyersContacted-aside">
          <Banner forClient/>
        </aside>
      </div>
    </div>

  );
};

export default LawyersContactedContainer;


   /* <div style={{width: '100%', height:'400px'}}>
     <div   style={{maxWidth: 680,  height:'400px', margin: '0 auto' }}>
        <div style={{padding: "24px 0"}}>
            <p className="messages-title">Mensajes</p>
            <p className="messages-subtitle">
En este panel podrás tener gestión de las conversaciones con tus asesores legales.            
            </p>
        </div>
        <div className="container-ms">
        <FilterDropdown
        id={id}
        open={openDropdown}
        anchorEl={anchorEl}
        onClose={handleCloseDropdown}
        handleOption={handleOption}
        option={option}
        // applyFilter={applyFilter}
      />
      <div style={isMobile ? { padding: '0 8px' } : null}>
        <div
          className="tabpanel-subhead"
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <p style={{ color: '#013957', marginBottom: 16, fontWeight: 'bold' }}>
            Todos los mensajes
          </p>

            <button 
              className="button-filter"
              style={{top:'unset'}}
              onClick={handleClickDropdown}
            >
              <img
                src={filter}
                style={{ marginRight: 8 }}
                width="24px"
                height="24px"
                alt="icono de filtro"
              />
              <span
                style={{
                  color: '#10587f',
                  fontSize: '14px',
                  marginRight: '10px',
                  verticalAlign: '30%',
                }}
              >
                Filtrar
              </span>
            </button>
        </div>
        
      </div>

             <MessageClient
               
            />
        </div>

        </div>
   </div> */